<template>
  <div :class="$style.headerCart">
    <div :class="$style.headerPrice">{{ orderTotalPrice | currency }}</div>
    <button :class="$style.cartBtn"
            @click="toggleCart">
      <svg v-svg
           :class="$style.cartIcon"
           symbol="cart-icon-kiosk" />
      <span
        v-if="cartLength"
        :class="$style.cartLabel">
        {{ cartLength }}
      </span>
    </button>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Getter, Mutation } from 'vuex-class';
import { CART_DISPLAY } from '@/apps/cart/store/types';

/**
 * Provides cart logo and current price
 */
@Component()
export default class KioskCartIcon extends Vue {
  @Getter showCart;
  @Getter orderTotalPrice;
  @Mutation(CART_DISPLAY) cartDisplay;
  @Getter cartLength;

  toggleCart() {
    this.cartDisplay(!this.showCart);
  }
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';
.cartBtn {
  position: relative;
  outline: none;
  .cartIcon {
    width: 68px;
    height: 68px;
  }
  .cartLabel {
    position: absolute;
    width: 36px;
    height: 36px;
    border-radius: 12px;
    top: -10px;
    right: -10px;
    background-color: $green-color;
    color: $white;
    font-family: 'Gotham', sans-serif;
    font-size: 22px;
    font-weight: 300;
    line-height: 36px;
  }
}

.headerCart {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .headerPrice {
    font-family: 'Gotham', sans-serif;
    font-size: 34px;
    font-weight: 300;
    line-height: 48px;
    margin-right: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/KioskCartIcon.vue